<template>
	<div>
		<h1>404 - Page not found</h1>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';
import { getModule as getStoreModule } from 'vuex-module-decorators';

import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import registerServiceWorker from '../../registerServiceWorker';
import AppStoreModule from '../../store/modules/AppStoreModule';

@Component
export default class NotFoundErrorModule extends Vue {
	private appStore: AppStoreModule = getStoreModule(AppStoreModule);

	protected mounted(): void {
		// register (and hence: update) service worker only for users that already have a service worker installed - it might require updating
		if (!!navigator.serviceWorker && !!navigator.serviceWorker.controller) {
			registerServiceWorker();
		}
	}

	/**
	 * New Services Workers will only be activated once all open tabs are closed or reloaded
	 * We won't automatically reload while in in present mode or create view.
	 * But to ensure updates are applied as soon as possible presentation list view automatically reloads upon available updates.
	 */
	protected get isApplicationReadyToBeUpdated(): boolean {
		return this.appStore.isApplicationReadyToBeUpdated;
	}

	/**
	 * New Services Workers will only be activated once all open tabs are closed or reloaded
	 * We won't automatically reload while in in present mode or create view.
	 * But to ensure updates are applied as soon as possible presentation list view automatically reloads upon available updates.
	 */
	@Watch('isApplicationReadyToBeUpdated')
	protected onApplicationReadyToBeUpdated(isApplicationReadyToBeUpdated: boolean): void {
		if (isApplicationReadyToBeUpdated) window.location.reload();
	}
}
</script>
